import { CopyButton as ChordsCopyButton } from '~/chords/CopyButton';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const CopyButton = withClassNameHoc(ChordsCopyButton);

CopyButton.displayName = 'CopyButton';
